module.exports = __webpack_public_path__ + "img/signature_pietra.f852420a.png";